<template lang="html">
  <div></div>
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop, Watch} from "vue-property-decorator";

import AutosplitDialogModal from "@/views/pages/finance/payout/AutosplitDialogModal.vue";
import {ModelEvents} from "capitalist-shared/src/core/model";
import {PayoutWebModel} from "capitalist-shared/src/finance/payments";

@Component({
  name: "AbstractPayoutForm",
  // mixins: [
  //   core.legacyFormsMixins,
  //   core.payoutMixins
  // ],
  // components: {
  //   'error-message': ErrorMessageBlock
  // }
})
export default class AbstractPayoutForm extends Vue {

  @Prop({default: ''})
  sourceAccountNumber: string

  @Prop({default: null})
  doc: number | null | string

  @Prop({
    default: function () {
      return {}
    }
  })
  overwriteValues: any

  template = null


  declare model: PayoutWebModel

  get submitable() {
    return true;
  }


  created() {
    this.$emit('created', this.submitable);
  }

  getQueryParam(param) {
    // if (URLSearchParams != 'undefined')
    // {
    //     const urlParams = new URLSearchParams(window.location.search);
    //     return urlParams.get(param);
    // }
    const url = window.location.href;
    const name = param.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  fillTemplate(template: any) {
    if (this.model) {
      this.template = {...template};
      // const updateSourceAccount: boolean = template.model.fromAccount != this.model.values.fromAccount;
      this.model.values = {...this.model.values, ...template.model};
      // const account: any = updateSourceAccount ? this.model.getSourceAccount() : null;
      this.$emit(ModelEvents.sourceAccountUpdate, template.model.fromAccount);
      // if (updateSourceAccount && account)
      //   this.$emit(ModelEvents.sourceAccountUpdate, account);
    }
  }

  templateIsDirty() {
    return this.template && this.template.model && Object.keys(this.template.model).filter((key) => this.template.model[key] !== this.model.values[key]).length > 0;
  }

  onModelLoadingFail() {
    this.$emit(ModelEvents.modelLoadingFail);
  }

  getModel() {
    // console.log('AbstractPayoutForm getModel', this.model);
    return this.model && typeof this.model == 'object' ? this.model : null;
  }

  submit() {

    this.$emit(ModelEvents.modelSubmitStart, this.model);
    if (this.model) {
      this.model.errors.clear();

      if (this.model.splitable) {
        this.model.checkSplit().then((result) => {

          this.model.values.autosplit = false;

          if (!result.splitRequired) {
            this.model.values.autosplit = false;
            this.model.submit().then((result: any) => {
              this.$emit(ModelEvents.documentCreated,
                result.document, this.model, result.verification);
            }, () => {
              this.$emit(ModelEvents.modelInvalidated, this.model);
            });

          } else {

            //console.log('splitResult', result);
            (this.$refs.autosplitModal as AutosplitDialogModal).ask(result.autosplit).then((choice) => {
              this.model.values.autosplit = choice === 'submit-partial';

              this.model.submit().then((result: any) => {
                this.$emit(ModelEvents.documentCreated,
                  result.document, this.model, result.verification);
              }, () => {
                this.$emit(ModelEvents.modelInvalidated, this.model);
              });

            }).catch(() => {
              this.$emit(ModelEvents.modelInvalidated, this.model);
            });

          }

        }).catch((err) => {

          this.model.values.autosplit = false
          // console.log('splitResultCatch', err);

          this.model.submit().then((result: any) => {
            this.$emit(ModelEvents.documentCreated, result.document, this.model, result.verification);
          }, () => {
            this.$emit(ModelEvents.modelInvalidated, this.model);
          });

        });
      } else {
        this.model.submit().then((result: any) => {
          this.$emit(ModelEvents.documentCreated, result.document, this.model, result.verification);
        }, () => {
          this.$emit(ModelEvents.modelInvalidated, this.model);
        });
      }

    }
  }

  setSourceAccountNumber(accountNumber) {
    if (this.model && this.model.values.fromAccount != accountNumber)
    {
      this.model.values.fromAccount = accountNumber;
    }
  }

  reset(values?: any) {
    if (this.model) {
      this.model.resetValues();
      if (values) this.model.setValues(values);
      const account = this.model.getSourceAccount();
      this.$emit(ModelEvents.sourceAccountUpdate, account);
    }
  }

  load() {
    this.$emit(ModelEvents.modelLoadingStart);
    if (this.model)
      this.model.load(this.sourceAccountNumber, this.doc).then((result: any) => {
        const m = {...result.model}
        if (this.doc) {
          // m.values.fromAccount = m.values.fromAccount
        } else {
          m.values.fromAccount = m.values.fromAccount || this.sourceAccountNumber;
        }
        this.model._setData(m)
        this.$emit(ModelEvents.modelLoaded, this.model);
        this.$emit('from-account-update', this.model.values.fromAccount);
        this.onModelLoaded(this.model);
      }, () => {
        this.$emit(ModelEvents.modelLoadingFail, this.model);
      });
  }

  onModelLoaded(model) {
  }


  @Watch('sourceAccountNumber')
  onSourceAccountNumberUpdate(newVal, oldVal) {
    // console.log('sourceAccountNumber', newVal, oldVal);
    if (newVal != oldVal) {
      this.setSourceAccountNumber(newVal);
    }
    // if (this.model)
    //   this.model.values.fromAccount = newVal;
  }


  @Watch('modelValues', {deep: true})
  onModelValuesUpdate(newVal, oldVal) {
    if (this.templateIsDirty()) {
      this.template = null;
      this.$parent.$emit('template-dirty');
    }
  }

  get modelSourceAccountNumber() {
    return this.model ? this.model.values.fromAccount : null;
  }

  @Watch('modelSourceAccountNumber')
  onModelSourceAccountNumberUpdate(newVal, oldVal) {
    this.$emit('from-account-update', newVal);
  }

  get modelValues(): any {
    return this.model ? this.model.values : {};
  }

  mounted() {
    this.setSourceAccountNumber(this.sourceAccountNumber);
    this.$emit('model', this.model);
    this.load()
  }
}
</script>

<style scoped lang="less">
.form-group-checkbox input[type=checkbox]:disabled+label {
  color: #999;
}
::v-deep {
  hr.payment-form-hr {
    margin-top: 25px;
    margin-bottom: 25px;
  }
}
</style>
